// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3ZSd8","subheader":"ReorderModal_subheader__BwHic","listWrap":"ReorderModal_listWrap__3n3iJ"};